module.exports = __webpack_public_path__ + "static/media/bali-bombings-feature-banner-md@1x.223ee9d3.png";